import { createTheme, darken, Theme } from '@mui/material';

import { globalTheme } from '../../../../shared/theme/theme';

export const formTheme: Theme = createTheme(globalTheme, {
  components: {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: globalTheme.palette.appWhite.main,
          border: `1px solid ${globalTheme.palette.appGrey.lightSilver}`,
          borderRadius: '4px',

          '&.input-focused, &:hover': {
            backgroundColor: globalTheme.palette.appWhite.main,
            borderBottom: `1px solid ${globalTheme.palette.appGrey.lightSilver}`,
          },
          '&.input-disabled': {
            backgroundColor: globalTheme.palette.appGrey.whiteSmoke,
            borderBottom: `1px solid ${globalTheme.palette.appGrey.lightSilver}`,
          },
        },
        underline: {
          '&&&:before': {
            borderBottom: 'none',
          },
          '&&:after': {
            borderBottom: 'none',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.btn': {
            textTransform: 'unset',
            fontSize: '20px',
            fontWeight: 300,
            '&-white': {
              border: `1px solid ${globalTheme.palette.appGrey.lightSilver}`,
              backgroundColor: globalTheme.palette.appWhite.main,
              boxShadow: 'unset',
              color: globalTheme.palette.black.main,
              '&:hover': {
                backgroundColor: globalTheme.palette.appGrey.lightSilver,
              },
            },
            '&-primary': {
              backgroundColor: globalTheme.palette.primary.main,
              boxShadow: 'unset',
              '&:hover': {
                backgroundColor: darken(globalTheme.palette.primary.main, 0.2),
              },
            },
            '&-filter-array': {
              backgroundColor: globalTheme.palette.black.main,
              marginBottom: '8px',
              boxShadow: 'unset',
              width: '56px',
              minWidth: 'unset',
              '&:hover': {
                backgroundColor:
                  globalTheme.palette.appGrey.filterArrayButtonHoverColor,
              },
            },
          },
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          '&.mui-chip-root': {
            backgroundColor: 'transparent',
            fontSize: 'unset',
            'span:first-of-type': { paddingLeft: '0px' },
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.mui-icon-button': {
            display: 'none',
          },
        },
      },
    },

    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: globalTheme.palette.black.main,
        },
      },
    },

    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': { fontSize: 28 },
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          alignSelf: 'flex-start',
          width: 'calc(100% - 32px)',
          margin: '8px auto 0 auto',
          lineHeight: '12px',
        },
      },
    },

    MuiFormControl: {
      styleOverrides: {
        root: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',

          '&.not-centered': {
            justifyContent: 'unset',
            alignItems: 'unset',
          },

          '&.radio-button-control': {
            '.label-focused': {
              color: globalTheme.palette.black.main,
            },

            '.radio-button': {
              padding: '0 9px',
            },

            '.radio-button-container': {
              '& > input:checked + span > svg:last-of-type': {
                transform: 'scale(1.2)',
              },
            },

            '.radio-button-label': {
              display: 'inline-flex',
              alignItems: 'center',
              paddingTop: '9px',
              minWidth: '130px',
            },
          },

          '.checkbox-input': {
            paddingTop: 0,
            paddingBottom: 0,
          },

          '.button-container-wrapper': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          },
          '.filters-array-input': {
            marginRight: '8px',
            marginBottom: '8px',
          },

          '&:not(:first-of-type)': {
            marginTop: '24px',
          },

          '& .input-label': {
            position: 'static',
            transform: 'unset',
            minWidth: '200px',
            textAlign: 'left',
          },

          '& .dropdown-autocomplete .mui-chip-root > svg': {
            display: 'none',
          },

          '& .input-helper-text': {
            fontSize: '14px',
            lineHeight: '16px',
            width: 'calc(100% - 32px)',
            marginTop: '8px',
          },

          '& .dropdown-autocomplete': {
            svg: {
              fill: globalTheme.palette.primary.main,
            },
          },

          '&.date-time-picker-input-field': {
            svg: {
              fill: globalTheme.palette.primary.main,
            },
          },

          '.input-label-filled.input-label-focused': {
            color: globalTheme.palette.black.main,
          },

          '.input-label-error.input-label-filled': {
            color: globalTheme.palette.error.dark,
          },

          '.input-label-focused': {
            color: globalTheme.palette.black.main,
          },

          '&.button-container': {
            '& button': {
              width: '232px',
              height: '56px',
            },
          },
          '&.reply-button-container': {
            display: 'block',
            '& button': {
              marginRight: '16px',
              height: '36px',
              width: '137px',
            },
          },
        },
      },
    },
  },
});
